import { render } from "./AdminDriverList.vue?vue&type=template&id=0a36de3c&scoped=true&ts=true&lang=true"
import script from "./AdminDriverList.vue?vue&type=script&lang=ts"
export * from "./AdminDriverList.vue?vue&type=script&lang=ts"

import "./AdminDriverList.vue?vue&type=style&index=0&id=0a36de3c&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a36de3c"]])

export default __exports__